import {pipe} from "@onflow/interaction"

export const resolve = pipe
